import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Blog() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Function to dynamically load the DropInBlog script
    const loadDropInBlogScript = () => {
      const existingScript = document.getElementById('dropinblog-script');
      if (!existingScript) {
        const script = document.createElement('script');
        // Dynamically set the baseUrl to the current origin
        const baseUrl = window.location.origin;
        script.src = `https://io.dropinblog.com/embedjs/b2aecd1b-f1e0-41c2-a25b-85f29a46798a.js?baseUrl=${baseUrl}`;
        script.id = 'dropinblog-script';
        script.async = true;
        script.onload = () => {
          setIsLoading(false);
          // Reinitialize DropInBlog if necessary
          if (window.dib && typeof window.dib.reinit === 'function') {
            window.dib.reinit();
          }
        };
        document.body.appendChild(script);
      } else {
        // If script already exists, just reinitialize
        setIsLoading(false);
        if (window.dib && typeof window.dib.reinit === 'function') {
          window.dib.reinit();
        }
      }
    };

    loadDropInBlogScript();

    // Cleanup function to remove the script if necessary
    return () => {
      // Optionally remove the script to prevent duplicate scripts
      // Uncomment the next line if you want to remove the script on unmount
      // document.getElementById('dropinblog-script')?.remove();
    };
  }, [location.pathname]); // Re-run when the route changes

  return (
    <>
      <style>{`
        .loader {
          border: 4px solid #f3f3f3;
          border-radius: 50%;
          border-top: 4px solid #78b657;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
          margin: 50px auto;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        #dib-posts {
          font-size: inherit;
          font-family: inherit;
        }
      `}</style>
      {isLoading && <div className="loader" />}
      <div id="dib-posts"></div>
    </>
  );
}